import { computed, onBeforeUnmount, onMounted, ref } from 'vue';
import { themeColor } from './chartDesign';

// Cores do canvas que acompanham o tema claro/escuro. O Chart.js não lê CSS,
// então recalculamos quando a classe/tema do documento muda.
export const useChartTheme = () => {
  const version = ref(0);
  let observer;

  onMounted(() => {
    observer = new MutationObserver(() => {
      version.value += 1;
    });
    [document.documentElement, document.body].forEach(element =>
      observer.observe(element, {
        attributes: true,
        attributeFilter: ['class', 'data-theme'],
      })
    );
  });

  onBeforeUnmount(() => observer?.disconnect());

  return computed(() => ({
    version: version.value,
    text: themeColor('--slate-11', '96 100 108'),
    grid: themeColor('--slate-6', '217 217 224', 0.6),
    surface: themeColor('--solid-1', '255 255 255'),
  }));
};
